<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';
</script>

<template>
    <PdfViewer title="サイトの利用環境" :api-url=url.api.environment.pdf />
</template>